module.exports = __webpack_public_path__ + "static/media/Tim Brenneman.430b41b3.png";